// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1GTHl","productName":"Table_productName__1fkfM"};